import React from "react";

import "./EventDetails.css";

import wineDinnerBg from "../assets/icons/wine-dinner-bg.png";

import contactIcon from "../assets/icons/touch.png";
import otpIcon from "../assets/icons/unlock.png";
import infoIcon from "../assets/icons/project.png";
import paymentIcon from "../assets/icons/wallet.png";

import calendarIcon from "../assets/icons/calendar.png";
import clockIcon from "../assets/icons/clock.png";
import locationIcon from "../assets/icons/location.png";
import dressCodeIcon from "../assets/icons/attire.png";

const EventDetails = ({
  EVENT,

  onRegisterClick,

  contact,
  setContact,

  isLoading,
  error,

  showOtp,
  otp,
  setOtp,

  handleOtpVerify,

  resendTimer,
  handleResendOtp,
}) => {
  // =====================================================
  // EVENT LOADING
  // =====================================================

  if (!EVENT) {
    return (
      <div className="er-loading">
        <div className="er-spinner"></div>

        <p>Loading event details...</p>
      </div>
    );
  }

  // =====================================================
  // FORMAT DATE
  // =====================================================

  const formatDate = (dateString) => {
    if (!dateString) {
      return "-";
    }

    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) {
      return dateString;
    }

    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // =====================================================
  // FORMAT TIME
  // =====================================================

  const formatTime = (timeString) => {
    if (!timeString) {
      return "-";
    }

    // API returns 09:00:00
    const parts = timeString.split(":");

    if (parts.length < 2) {
      return timeString;
    }

    let hours = Number(parts[0]);
    const minutes = parts[1];

    const period = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${hours}:${minutes} ${period}`;
  };

  // =====================================================
  // HOW IT WORKS
  // =====================================================

  const steps = [
    {
      icon: contactIcon,
      label: "Enter contact",
    },

    {
      icon: otpIcon,
      label: "Verify OTP",
    },

    {
      icon: infoIcon,
      label: "Check info",
    },

    {
      icon: paymentIcon,
      label: "Payment",
    },
  ];

  // =====================================================
  // RENDER
  // =====================================================

  return (
    <div className="er-details-view">
      {/* =================================================
          LEFT EVENT PANEL
      ================================================= */}

      <div
        className="er-left-panel"
        style={{
          backgroundImage: `url(${wineDinnerBg})`,
        }}
      >
        <div className="er-left-overlay"></div>

        <div className="er-event-content">
          {/* EVENT STATUS */}

          <span className="er-badge">{EVENT.status || "UPCOMING EVENT"}</span>

          {/* EVENT TITLE */}

          <h1 className="er-title">{EVENT.title || "Event"}</h1>

          {/* CATEGORY */}

          {EVENT.category && (
            <div
              style={{
                fontSize: "12px",
                fontWeight: "600",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "#bfa15f",
                marginBottom: "12px",
              }}
            >
              {EVENT.category}
            </div>
          )}

          {/* DESCRIPTION */}

          <p className="er-description">
            {EVENT.description || "Join us for this exclusive event."}
          </p>

          {/* =================================================
              EVENT META
          ================================================= */}

          <div className="er-meta-grid">
            {/* DATE */}

            <div className="er-meta-item">
              <img src={calendarIcon} alt="Date" className="er-meta-icon" />

              <div>
                <div className="er-meta-label">{formatDate(EVENT.date)}</div>

                <div className="er-meta-sub">{EVENT.day || "Event Date"}</div>
              </div>
            </div>

            {/* TIME */}

            <div className="er-meta-item">
              <img src={clockIcon} alt="Time" className="er-meta-icon" />

              <div>
                <div className="er-meta-label">
                  {formatTime(EVENT.checkin_time)}
                </div>

                <div className="er-meta-sub">Check-in</div>
              </div>
            </div>

            {/* VENUE */}

            <div className="er-meta-item">
              <img src={locationIcon} alt="Location" className="er-meta-icon" />

              <div>
                <div className="er-meta-label">{EVENT.venue || "-"}</div>

                <div className="er-meta-sub">{EVENT.venue_city || ""}</div>
              </div>
            </div>

            {/* DRESS CODE */}

            <div className="er-meta-item">
              <img
                src={dressCodeIcon}
                alt="Dress Code"
                className="er-meta-icon"
              />

              <div>
                <div className="er-meta-label">{EVENT.dress_code || "-"}</div>

                <div className="er-meta-sub">Dress Code</div>
              </div>
            </div>
          </div>

          {/* =================================================
              PRICING
          ================================================= */}

          <div className="er-pricing">
            {/* MEMBER */}

            <div className="er-price-card">
              <span className="er-price-type">Member</span>

              <span className="er-price-amount">
                {EVENT.currency || "$"}
                {Number(EVENT.member_price || 0).toFixed(2)}
              </span>

              <span className="er-price-per">per person</span>
            </div>

            {/* NON MEMBER */}

            <div className="er-price-card">
              <span className="er-price-type">Non-Member</span>

              <span className="er-price-amount">
                {EVENT.currency || "$"}
                {Number(EVENT.guest_price || 0).toFixed(2)}
              </span>

              <span className="er-price-per">per person</span>
            </div>
          </div>

          {/* =================================================
              HIGHLIGHTS
          ================================================= */}

          {Array.isArray(EVENT.highlights) && EVENT.highlights.length > 0 && (
            <div className="er-highlights-grid">
              {EVENT.highlights.map((highlight, index) => (
                <div key={index} className="er-highlight">
                  {highlight.icon && (
                    <img
                      src={highlight.icon}
                      alt={highlight.label || "Highlight"}
                      className="er-highlight-icon"
                    />
                  )}

                  <div>
                    <div className="er-highlight-label">{highlight.label}</div>

                    <div className="er-highlight-sub">{highlight.sub}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* =================================================
          RIGHT BOOKING PANEL
      ================================================= */}

      <div className="er-right-panel">
        <div className="er-form-container">
          {/* TITLE */}

          <h2 className="er-form-title">Book Now</h2>

          {/* DIVIDER */}

          <div className="er-divider">
            <span className="er-divider-line" />

            <span className="er-divider-diamond" />

            <span className="er-divider-line" />
          </div>

          {/* =================================================
              CONTACT FORM
          ================================================= */}

          <form onSubmit={onRegisterClick} className="er-register-form">
            <div className="er-input-group">
              <label className="er-input-label">
                Enter your mobile number or email to get started
              </label>

              <div className="er-input-wrapper">
                <span className="er-input-icon">✉</span>

                <input
                  className="er-input"
                  type="text"
                  placeholder="Enter your mobile or email"
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                  disabled={isLoading}
                  autoFocus
                />
              </div>
            </div>

            {/* ERROR */}

            {error && <div className="er-error">{error}</div>}

            {/* BOOK NOW */}

            <button
              type="submit"
              className="er-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? "Checking..." : "Book Now →"}
            </button>

            {/* =================================================
                OTP
            ================================================= */}

            {showOtp && (
              <div className="er-otp-inline">
                <div className="er-otp-inline-divider">
                  <span className="er-divider-line"></span>

                  <span className="er-divider-label">VERIFY YOUR IDENTITY</span>

                  <span className="er-divider-line"></span>
                </div>

                <p className="er-otp-inline-subtitle">
                  We've sent an OTP to
                  <strong> {contact}</strong>
                </p>

                <input
                  className="er-input er-otp-input"
                  value={otp}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    setOtp(value);
                  }}
                  maxLength={6}
                  placeholder="Enter OTP"
                  inputMode="numeric"
                />

                <button
                  type="button"
                  className="er-submit-btn"
                  onClick={handleOtpVerify}
                  disabled={isLoading || otp.length < 4}
                >
                  {isLoading ? "Verifying..." : "Verify OTP"}
                </button>

                <button
                  type="button"
                  className="er-resend-btn"
                  onClick={handleResendOtp}
                  disabled={resendTimer > 0 || isLoading}
                >
                  {resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend OTP"}
                </button>
              </div>
            )}
          </form>

          {/* =================================================
              HOW IT WORKS
          ================================================= */}

          <div className="er-divider-text">
            <span className="er-divider-line" />

            <span className="er-divider-label">How It Works</span>

            <span className="er-divider-line" />
          </div>

          <div className="er-steps">
            {steps.map((step, index) => (
              <React.Fragment key={index}>
                <div className="er-step">
                  <div className="er-step-circle">
                    <img
                      src={step.icon}
                      alt={step.label}
                      className="er-step-icon"
                    />

                    <span className="er-step-num">{index + 1}</span>
                  </div>

                  <span className="er-step-label">{step.label}</span>
                </div>

                {index < steps.length - 1 && (
                  <span className="er-step-arrow">→</span>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* =================================================
              EXISTING / NEW USER
          ================================================= */}

          <div className="er-outcome-cards">
            <div className="er-outcome er-outcome-existing">
              <span className="er-outcome-icon">✓</span>

              <div>
                <div className="er-outcome-title">Existing User</div>

                <div className="er-outcome-desc">We'll fetch your details</div>
              </div>
            </div>

            <div className="er-outcome-sep">OR</div>

            <div className="er-outcome er-outcome-new">
              <span className="er-outcome-icon">+</span>

              <div>
                <div className="er-outcome-title">New Guest</div>

                <div className="er-outcome-desc">
                  Complete registration form
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              SECURITY
          ================================================= */}

          <div className="er-security">
            <img
              src={otpIcon}
              alt="Secure verification"
              className="er-security-icon"
            />

            <span className="er-security-text">
              Your information is secure and used only for event registration
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
